import { Image } from 'native-base';
import { ImageProps } from 'react-native';

const FastImage = (props: ImageProps) => <Image {...props} alt="EasyPixyImage" />;

export { FastImage };
